<template>
    <div class="m-0 p-0" v-show="Loading.isLoading">
        <div class="loading-screen-bg"></div>
        <!--<BackgroundStars class="background-stars" v-show="Loading.isLoading" />-->
        <div class="logo-container">
            <img alt="Kahin.AI" :src="require('@/assets/images/logo/128.png')" class="logo" />
        </div>
        <LoadingIndicator class="loading-indicator"/>

        <div class="loading-message-container p-4">
            <div class="title">{{ Loading.title }}</div>
            <div class="description mt-4">{{ Loading.description }}</div>
        </div>
    </div>
</template>

<script>
import {mapStores, mapState, mapActions, setMapStoreSuffix} from 'pinia';
import LoadingIndicator from "./LoadingIndicator.vue";
import BackgroundStars from "@/components/BackgroundStars.vue";
import {Loading} from "@/store/Loading";

setMapStoreSuffix("");

export default {
    components: {
        LoadingIndicator,
        BackgroundStars
    },

    computed: {
        ...mapStores(Loading)
    }
}
</script>

<style scoped>
.logo-container {
    position: fixed;
    left: 0;
    top: 60px;
    text-align: center;
    color: #ffffff;
    z-index: 999999;
    width: 100%;
}

.loading-screen-bg {
    width: 100%;
    height: 100%;
    display: block;
    position: fixed;
    z-index: 9999;
    background: #0B091899;
}

.loading-message-container {
    position: fixed;
    bottom: 10%;
    left: 0;
    width: 100%;
    text-align: center;
    color: #ffffff;
    z-index: 999999;
}

.loading-message-container .title {
    color: white;
    font-size: 20px;
    font-family: Poppins;
    font-weight: 500;
    word-wrap: break-word
}

.loading-message-container .description {
    color: white;
    font-size: 14px;
    font-family: Poppins;
    font-weight: 400;
    word-wrap: break-word
}

.background-stars {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    background: red;
}

.loading-indicator {
    top: 180px;
    position: fixed;
}
</style>